<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_shipment.edit_order') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="shipment.shipping_service != 'OTRA'">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="shipment.shipping_service" :items="shippingServices" item-text="text" item-value="value" :label="$t('edit_shipment.shipping_service')" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="order.order_type" :items="orderTypes" item-value="value" item-text="text" :label="$t('edit_shipment.order_type')" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.name" :label="$t('edit_shipment.buyers_name')" :rules="rules_name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.phone" :label="$t('edit_shipment.phone')" :rules="rules_phone"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.email" :label="$t('edit_shipment.email')" :rules="rules_email"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.zipcode" :label="$t('edit_shipment.zip_code')" :rules="rules_zipcode"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.neighborhood" :label="$t('edit_shipment.neighborhood')" :rules="is_local ? rules_required : []"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.street" :label="$t('edit_shipment.street')" :rules="is_local ? rules_street : rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="3" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.external_number" :label="$t('edit_shipment.n_ext')" :rules="is_local ? rules_external_number : []"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.internal_number" :label="$t('edit_shipment.n_int')" :rules="is_local ? rules_internal_number : []"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.state" :label="$t('edit_shipment.state')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.municipality" :label="$t('edit_shipment.municipality')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.consignee.comments" :label="$t('edit_shipment.references')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="shipment.total_price" :label="$t('edit_shipment.total_cost')" :rules="rules_total_price"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="3" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="product_selected.id" item-value="id" item-text="sku" :loading="products_load" :items="products" :label="$t('edit_shipment.product')"></v-autocomplete> 
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-text-field class="py-0" v-model="product_selected.quantity" :label="$t('edit_shipment.quantity')"></v-text-field>
                            </v-col>
                            <v-col cols="1" class="py-0">
                                <v-btn class="right white_highlight--text" color="secondary" @click="addProduct" >
                                    {{ $t('edit_shipment.add') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <datatable class="custom_table_class" :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel" >
                                {{ $t('create_appointment.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" >
                                {{ $t('create_appointment.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
export default {
    computed: {
        rules_required(){ return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        rules_number(){ return [
            v => v == null || /^(|\d)+$/.test(v) || this.$t('edit_appointment.validations.numeric'),
            v => !!v || this.$t('create_appointment.validations.required_field')
        ]},
        rules_name(){ return [
            v => !!v || this.$t('create_appointment.validations.required_field'),
            v => v.length >= 3 && v.toString().length <= 35 || this.$t('edit_shipment.validations.name'),
        ]},
        rules_phone(){ return [
            v => v.length === 10 || this.$t('edit_shipment.validations.phone'),
            v => /^(\d*\.)?\d+$/.test(v) || this.$t('edit_appointment.validations.numeric'),
        ]},
        rules_street(){ return [
            v => !!v || this.$t('create_appointment.validations.required_field'),
            v => v.toString().length <= 23 || this.$t('edit_shipment.validations.street'),
        ]},
        rules_external_number(){ return [
            v => !!v || this.$t('create_appointment.validations.required_field'),
            v => v.length <= 5 || this.$t('edit_shipment.validations.external_number'),
        ]},
        rules_internal_number(){ return [
            v => v.length <= 5 || this.$t('edit_shipment.validations.internal_number'),
        ]},
        rules_zipcode(){ return [
            v => v.length === 5 || this.$t('edit_shipment.validations.zipcode'),
            v => /^(\d*\.)?\d+$/.test(v) || this.$t('edit_appointment.validations.numeric'),
        ]},
        rules_comments(){ return [
            v => (v.toString().length == 0 || (v.toString().length >= 3 && v.toString().length <= 255)) || this.$t('edit_shipment.validations.comments'),
        ]},
        rules_email(){ return [v => (v == null || v.length == 0 || /.+@.+\..+/.test(v)) || this.$t('edit_shipment.validations.email')]},
        rules_total_price(){ return [
            v => !!v || this.$t('create_appointment.validations.required_field'),
            v => /^(\d*\.)?\d+$/.test(v) || this.$t('edit_appointment.validations.numeric'),
            v => parseFloat(v) <= 8000 || this.$t('edit_shipment.validations.total'),
        ]},
        headers(){ 
            return [
                { text: this.$t('edit_shipment.product'), value: 'product.sku', class: 'text-uppercase', width:'60%' },
                { text: this.$t('edit_shipment.quantity'), value: 'quantity', class: 'text-uppercase', width:'30%' },
                { text: '', value: 'actions', class: 'text-uppercase', width:'10%' },
            ]
        }
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            actions: [
                {
                    name: this.$t('edit_shipment.delete_product'),
                    icon: {
                        color: 'error',
                        icon: 'disabled_by_default'
                    },
                    method: 'deleteProduct',
                }
            ],
            id: this.$route.params.id,
            shippingServices: this.$store.state.shipping_services,
            orderTypes:[{ value: "cod", text: this.$t('edit_shipment.cod')},{ value: "prepaid", text: this.$t('edit_shipment.prepaid')}],
            props: {
                items: [],
                search: ''
            },
            products: [],
            product_selected: {
                sku: "",
                id: "",
                quantity: "",
                unit_price: "",
            },
            products_load: false,
            shipment: {
                shipping_service: '',
                unique_order_number: '',
                warehouse_id: this.$store.state.warehouseId,
                cod: false,
                consignee: {
                    name: '',
                    phone: '',
                    email: '',
                    neighborhood: '',
                    street: '',
                    internal_number: '',
                    external_number: '',
                    comments: '',
                    state: '',
                    municipality: '',
                    zipcode: ''    
                },
                order_details:[],
                total_price: ''
            },
            is_local: true,
            order: {
                order_type: '',
            },
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.edit_pendind_order";
    },
    methods: {
        index(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'shipment/getOrderInformation/' + this.id, {headers: {}})
            .then((response) => {
                response.data = response.data.data.attributes;
                this.products = [];
                this.shipment.unique_order_number = response.data.uniqueOrderNumber;
                this.shipment.shipping_service = response.data.shippingService;
                this.shipment.consignee.name = response.data.consignee.name;
                this.shipment.consignee.zipcode = response.data.consignee.zipcode;
                
                if(response.data.consignee.country.toLowerCase() != "mexico" && response.data.consignee.country.toLowerCase() != "méxico" && response.data.consignee.country.toLowerCase() != "mx") this.is_local = false;

                this.shipment.consignee.country = response.data.consignee.country.toLowerCase();
                this.shipment.consignee.phone = response.data.consignee.phone;
                this.shipment.consignee.email = response.data.consignee.email;
                this.shipment.consignee.neighborhood = response.data.consignee.neighborhood;
                this.shipment.consignee.street = response.data.consignee.street;
                this.shipment.consignee.external_number = response.data.consignee.externalNumber ?? "";
                this.shipment.consignee.internal_number = response.data.consignee.internalNumber ?? "";
                this.shipment.consignee.state = response.data.consignee.state;
                this.shipment.consignee.municipality = response.data.consignee.municipality;
                this.shipment.consignee.comments = response.data.consignee.comments ?? "---";
                this.order.order_type = response.data.cod == false ? "prepaid" : "cod";
                this.shipment.total_price = response.data.total;
                response.data.shipmentProductDetail.data.forEach( x => {
                    x = x.attributes;
                    x.actions = JSON.parse(JSON.stringify(this.actions));
                    x.parameters = x.product.sku;
                    this.props.items.push(x);
                })

                // Get products by client
                this.products_load = true;
                this.$http.get(this.$store.state.chronosApi + 'getProducts/' + response.data.client.id, {headers: {Authorization: lsToken}})
                .then((response) => {
                    response.data = response.data.data;
                    response.data.forEach( x => {
                        x = x.attributes;
                        this.products.push(x);
                    })
                    this.products_load = false;
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        save(){
            const formVal = this.$refs.form.validate()
            if(formVal){
                this.$store.state.loaderProps.visible = true;
                const lsToken = localStorage.getItem("access_token");
                this.shipment.order_details = [];
                this.props.items.forEach( x => {
                    delete x.id;
                    delete x.parameters;
                    delete x.actions;
                    if(x.product) x.sku = x.product.sku;
                    delete x.product;
                    if(x.unitPrice == null) x.unitPrice = 1;

                    this.shipment.order_details.push(x);
                });
                this.shipment.cod = (this.order.order_type == "prepaid" ? false : true);
                this.$http.patch(this.$store.state.chronosApi + 'shipment/update/' + this.id, this.shipment, {headers: {Authorization: lsToken}})
                .then((response) => {
                    if(response.status === 200){
                        this.snackbar = {
                            visible: true,
                            color: 'success2',
                            text: this.$t('edit_shipment.success')
                        }

                        this.$router.go(-1);  
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('edit_shipment.form_invalid')
                }
            }
        },
        addProduct(){
            if(this.product_selected.id != "" && this.product_selected.quantity != ""){
                // check if sku is already in list
                var exist =  false;
                this.props.items.forEach( x => {
                    if(x.id == this.product_selected.id) exist = true;
                })

                if(exist == true){
                    this.props.items.forEach( x => {
                        if(x.id == this.product_selected.id) x.quantity = parseInt(this.product_selected.quantity) + parseInt(x.quantity);
                    })
                }
                else {
                    const new_product = {
                        id: parseInt(this.product_selected.id),
                        quantity: parseInt(this.product_selected.quantity),
                        unit_price: this.product_selected.unit_price,
                        actions: JSON.parse(JSON.stringify(this.actions)),
                        parameters: this.products.find(x => x.id == this.product_selected.id).sku,
                        product: {
                            sku: this.products.find(x => x.id == this.product_selected.id).sku,
                        }
                    }

                    this.props.items.push(new_product);
                }

                this.product_selected.sku = "";
                this.product_selected.id = "";
                this.product_selected.quantity = "";
                this.product_selected.unit_price = "";
            }
        },
        deleteProduct(sku){
            console.log(sku);
            const index = this.props.items.findIndex(x => x.product.sku === sku);
            this.props.items.splice(index, 1);
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
        'shipment.consignee.country': function() {
            if(this.shipment.consignee.country == "mexico") this.is_local = true;
            else this.is_local = false;
        }
    }
}
</script>

<style lang="css">
</style>